export default __webpack_public_path__ + "static/media/page-layout.92cfb10f.svg";